"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Inserter = function () {
  /**
   * Constructor
   * @param {string} source
   */
  function Inserter(source) {
    _classCallCheck(this, Inserter);

    this.offset = 0;
    this.source = source;
    this.original = source;
  }

  /**
   * Insert
   * @param {string} string
   * @param {number} startPos
   * @param {number} [endPos=startPos]
   */


  _createClass(Inserter, [{
    key: "insert",
    value: function insert(string, startPos) {
      var endPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startPos;

      this.source = "" + this.source.slice(0, startPos + this.offset) + string + this.source.slice(endPos + this.offset);
      this.offset += string.length - endPos + startPos;
    }
  }]);

  return Inserter;
}();

module.exports = Inserter;


//////////////////
// WEBPACK FOOTER
// ../lib/Inserter.js
// module id = 171
// module chunks = 0